import React, { useState, useEffect } from "react";
import moment from "moment";


import { useHistory } from "react-router-dom";

import Menu from "../../components/menu/Menu";
import { getCaixa } from "../../services/caixaService";


function Item1() {
  const history = useHistory();

  const [caixa, setCaixa] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");

    getCaixa(token)
      .then((response) => {
        console.log(response);
        setCaixa(response);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401)
          return history.push("/");

        setError(err.response ? err.response.data : err.message);
      });
  }, []);

  const positivo = (
    <svg
      className="icon icon-xs text-success"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );

  const negativo = (
    <svg
      className="icon icon-xs text-danger"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );

  let valor;
  valor =
    caixa.length > 0 &&
    ((caixa[0].valor / caixa[1].valor - 1) * 100).toFixed(2);


  return (
    <>
      <Menu />
      <main>

        <section className="vh-lg-100 mt-5 mt-lg-0 bg-soft d-flex align-items-center">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-6 col-xl-4 mb-4">
                <div className="card border-0 shadow">
                  <div className="card-body">
                    <div className="row d-block d-xl-flex align-items-center">
                      <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                        <div className="icon-shape icon-shape-secondary rounded me-4 me-sm-0">
                          <svg
                            className="icon"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </div>
                        <div className="d-sm-none">
                          <h2 className="fw-extrabold h5">Receita</h2>
                          <h3 className="mb-1">
                            {caixa.length > 0 && caixa[0].valor} €
                          </h3>
                        </div>
                      </div>
                      <div className="col-12 col-xl-7 px-xl-0">
                        <div className="d-none d-sm-block">
                          <h2 className="h6 text-gray-400 mb-0">Receita</h2>
                          <h3 className="fw-extrabold mb-2">
                            {caixa.length > 0 && caixa[0].valor} €
                          </h3>
                        </div>
                        <small className="d-flex align-items-center text-gray-500">
                          {moment().format("MMM 01")} -{" "}
                          {moment().format("MMM DD")},
                        </small>
                        <div className="small d-flex mt-1">
                          <div>
                            Mês anterior{" "}
                            <span
                              className={
                                caixa.length > 0 && valor > 0
                                  ? "text-success fw-bolder"
                                  : "text-danger fw-bolder"
                              }
                            >
                              {caixa.length > 0 && valor > 0
                                ? positivo
                                : negativo}
                              {valor} %
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default Item1;
